import { Container, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import PublicationsTab from "./PublicationsTab";
import NewsTab from "./NewsTab";
import VideosTab from "./VideosTab";
import PhotosTab from "./PhotosTab";

function MediaTabButton({
  dir,
  onClick,
  labelId,
  className,
  style,
}) {
  return (
    <div className="col-3">
      <Container
        role="button"
        className={className}
        style={style}
        onClick={onClick}
      >
        <Row>
          <img
            className="img1"
            src={process.env.PUBLIC_URL + "/image/sb.svg"}
            alt="arrow"
            loading="lazy"
            height="100px"
            style={{
              transform: dir === "rtl" ? "rotate(0deg)" : "rotate(90deg)",
            }}
          />
        </Row>
        <Row style={{ paddingBottom: "10px" }}>
          <center>
            <h4 style={{ color: "#FFFFFF" }}>
              <FormattedMessage id={labelId} />
            </h4>
          </center>
        </Row>
      </Container>
    </div>
  );
}

function TabPointer({ active }) {
  return (
    <div className="col-3">
      {active && (
        <center>
          <img
            className="img1"
            src={process.env.PUBLIC_URL + "/image/pointer.png"}
            alt="arrow"
            loading="lazy"
            height="25px"
          />
        </center>
      )}
    </div>
  );
}

export default function MediaTabsSection({
  dir,
  newMedia,
  setNewMedia,
  publications,
  latestNews,
  videos,
  photos,
}) {
  return (
    <div>
      <h4 style={{ fontWeight: "bold" }}>
        <FormattedMessage id="the-new-in" /> ...
      </h4>
      <br />
      <div className="row">
        <MediaTabButton
          dir={dir}
          onClick={() => setNewMedia(0)}
          labelId="publications"
          className="rounded-5 main-bg"
        />
        <MediaTabButton
          dir={dir}
          onClick={() => setNewMedia(1)}
          labelId="theNews"
          className="rounded-5"
          style={{ backgroundColor: "#0C42E1" }}
        />
        <MediaTabButton
          dir={dir}
          onClick={() => setNewMedia(2)}
          labelId="video"
          className="rounded-5"
          style={{ backgroundColor: "#761431" }}
        />
        <MediaTabButton
          dir={dir}
          onClick={() => setNewMedia(3)}
          labelId="photos"
          className="rounded-5 second-bg"
        />
      </div>
      <br />
      <div>
        <div className="row">
          <TabPointer active={newMedia === 0} />
          <TabPointer active={newMedia === 1} />
          <TabPointer active={newMedia === 2} />
          <TabPointer active={newMedia === 3} />
        </div>
        {newMedia === 0 && <PublicationsTab publications={publications} />}
        {newMedia === 1 && <NewsTab latestNews={latestNews} />}
        {newMedia === 2 && <VideosTab videos={videos} />}
        {newMedia === 3 && <PhotosTab photos={photos} />}
      </div>
    </div>
  );
}
